export default "/images/vendor/flag-icon-css/flags/4x3/cl.svg?b9ff305a088060fd040a79f1252e9bd8";